import React from "react";
import { Route, Routes } from "react-router-dom";
import { Navigate } from "react-router";
import MainContent from "./pages/MainContent";
import NotFoundPage from "./pages/NotFoundPage";
import { Container } from "frno-react";
import { TablePath, TableType } from "../data/TableType";
import {
  PensionProductType,
  PensionProductTypeData,
} from "../data/PensionProductType";

export default function Gebyrsjekken() {
  return (
    <main className="gebyrsjekken">
      <Container mt={10} type="lg">
        <Routes>
          <Route
            index
            element={
              <Navigate
                to={`${
                  PensionProductTypeData[
                    PensionProductType.PENSJONSKAPITALBEVIS
                  ].path
                }${TablePath[TableType.COMPANIES]}`}
                replace
              />
            }
          />
          <Route path="/:productType/:tableType" element={<MainContent />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Container>
    </main>
  );
}
